<div id="clover-form">
  <form (ngSubmit)="submitForm($event)" id="payment-form" #form>
    <!-- this form contains the card data fields -->
    <div class="d-flex form-group flex-column flex-lg-row mb-4">
      <div class="form-floating">
        <div id="card-number" class="field card-number form-control"></div>
        <label for="card-number">Card Number</label>
        @if (errors?.CARD_NUMBER) {
          <div class="input-errors" id="card-number-errors" role="alert">{{ errors.CARD_NUMBER }}</div>
        }
      </div>

      <div class="form-floating">
        <div id="card-date" class="field form-control"></div>
        <label for="card-date">Expiry</label>
        @if (errors?.CARD_DATE) {
          <div class="input-errors" id="card-date-errors" role="alert">{{ errors.CARD_DATE }}</div>
        }
      </div>
    </div>

    <div class="d-flex form-group flex-column flex-lg-row">
      <div class="form-floating">
        <div id="card-cvv" class="field form-control"></div>
        <label for="card-cvv">Card CVV</label>
        @if (errors?.CARD_CVV) {
          <div class="input-errors" id="card-cvv-errors" role="alert">{{ errors.CARD_CVV }}</div>
        }
      </div>

      <div class="form-floating">
        <div id="card-postal-code" class="field form-control"></div>
        <label for="card-postal-code">Zip Code</label>
        @if (errors?.CARD_POSTAL_CODE) {
          <div class="input-errors" id="card-postal-code-errors" role="alert">{{ errors.CARD_POSTAL_CODE }}</div>
        }
      </div>
    </div>

    <div>
      <div class="form-row">
        <div id="card-apple" class="third-width"></div>
        <div class="input-errors" id="card-apple-errors" role="alert"></div>
      </div>

      <div>
        <div id="card-google" class="third-width"></div>
        <div class="input-errors" id="card-google-errors" role="alert"></div>
      </div>
    </div>

    @if (hasError) {
      <div class="alert alert-danger mt-3" role="alert">{{ 'fgbcl.payment.clover.error.message' | translate }}</div>
    }

    <div id="card-response" role="alert"></div>
    <div style="display: flex; justify-content: center" class="button-container mt-5">
      <button
        class="btn d-flex align-items-center btn-primary rounded"
        style="margin-bottom: 20px"
        id="payment-request-button"
        type="submit"
        [disabled]="isLoading"
      >
        <div class="loading-wrapper me-2" *ngIf="isLoading">
          <fgbcl-loading size="small" />
        </div>
        Submit Payment
      </button>
    </div>
  </form>
  <div class="clover-footer"></div>
</div>
